import React, { useState, useRef } from "react";
import advatxImg from "../assets/sliderImages/advatx.avif";  
import regeneraImg from "../assets/sliderImages/regenera.avif";
import pbserumImg from "../assets/sliderImages/pbserum.avif";  
import gouriImg from "../assets/sliderImages/gouri.avif";  
import melineImg from "../assets/sliderImages/meline.avif";
import "./Slider.css";

export default function Slider() {
  const gamesArray = [
    {
      title: "ADVATx",
      desc: "Láser dermatológico de luz dorada con 2 longitudes de onda.",
      img: advatxImg ,
    },
    {
      title: "Regenera Activa AMT",
      desc: "Tecnología médica para la regeneración capilar con exosomas.",
      img: regeneraImg ,
    },
    {
      title: "pbserum",
      desc: "Las únicas enzimas recombinantes en el mundo.",
      img: pbserumImg ,
    },
    {
      title: "GOURI",
      desc: "Bioestimulador de 100% policaprolactona líquida para la producción de colágeno.",
      img: gouriImg ,
    },
    {
      title: "MELINE",
      desc: "La única línea especializada en despigmentación cutánea.",
      img: melineImg ,
    },
  ];

  const [activeIndex, setActiveIndex] = useState(0);
  const containerRef = useRef(null);
  const CARD_WIDTH = 300;
  const GAP = 20;
  const VISIBLE_OFFSET = 1;

  const next = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % gamesArray.length);
  };

  const prev = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === 0 ? gamesArray.length - 1 : prevIndex - 1
    );
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Botón izquierdo */}
      <button
        onClick={prev}
        style={{
          position: "absolute",
          left: 12,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 30,
          background: "rgba(0,0,0,0.45)",
          color: "#fff",
          border: "none",
          width: 40,
          height: 40,
          borderRadius: 20,
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        ❮
      </button>

      {/* Contenedor de las tarjetas */}
      <div
        ref={containerRef}
        style={{
          position: "relative",
          width: CARD_WIDTH + VISIBLE_OFFSET * CARD_WIDTH * 2 + 100,
          height: 420,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {gamesArray.map((game, index) => {
          const rawOffset = index - activeIndex;
          let offset = rawOffset;
          const n = gamesArray.length;
          if (offset > n / 2) offset -= n;
          if (offset < -n / 2) offset += n;

          const x = offset * (CARD_WIDTH + GAP);
          const scale =
            offset === 0 ? 1 : offset === 1 || offset === -1 ? 0.92 : 0.8;
          const opacity =
            Math.abs(offset) > 2 ? 0 : Math.max(0.45, 1 - Math.abs(offset) * 0.25);
          const zIndex = 20 - Math.abs(offset);

          return (
            <div
              key={index}
              onClick={() => setActiveIndex(index)}
              style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: `translate(calc(-50% + ${x}px), -50%) scale(${scale})`,
                width: CARD_WIDTH,
                height: 380,
                borderRadius: 18,
                backgroundImage: `url(${game.img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
                overflow: "hidden",
                cursor: "pointer",
                transition:
                  "transform 1200ms cubic-bezier(0.25, 1, 0.5, 1), opacity 800ms ease-in-out",
                opacity,
                zIndex,
              }}
            >
              {/* Capa de gradiente */}
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(to top, rgba(0,0,0,0.75), rgba(0,0,0,0.12))",
                }}
              />
              {/* Texto */}
              <div
                style={{
                  position: "absolute",
                  bottom: 16,
                  left: 16,
                  right: 16,
                  color: "#fff",
                  zIndex: 10,
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    fontSize: 20,
                    fontWeight: 700,
                  }}
                >
                  {game.title}
                </h3>
                {index === activeIndex && (
                  <p style={{ marginTop: 8, fontSize: 14 }}>{game.desc}</p>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Botón derecho */}
      <button
        onClick={next}
        style={{
          position: "absolute",
          right: 12,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 30,
          background: "rgba(0,0,0,0.45)",
          color: "#fff",
          border: "none",
          width: 40,
          height: 40,
          borderRadius: 20,
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        ❯
      </button>
    </div>
  );
}
